<div *ngIf="reportReportElement != null" style="width: 100%;">
  <table style="width: 100%;">
    <tbody>
      <tr>
        <td style="vertical-align: middle; text-align: left; font-size: 30px; ">
          <div style="font-size: 30px; white-space: nowrap;">
            <span>{{reportReportElement.Name}}</span>
            &nbsp;
            <span  [style.color]="reportReportElement.LatestLagInDays != null ? getPointColor(reportReportElement.LatestLagInDays) : 'black'">{{reportReportElement.LatestLagInDays != null ? reportReportElement.LatestLagInDays.toFixed(1) : (reportReportElement.MissingConfiguration ? 'missing config...' : 'no data...')}}</span>
          </div>
        </td>
        <td style="opacity: 0.6; vertical-align: middle; text-align: right; font-size: 30px; ">
          <div style="font-size: 30px; white-space: nowrap;">{{thePeriod}}</div>
        </td>
      </tr>
    </tbody>
  </table>

  <dx-chart id="chart" [size]="{height: 220}" [dataSource]="data" [customizePoint]="customizePoint" [customizeLabel]="customizeLabel" (onInitialized)="theChartOnInitialized($event)" (onDrawn)="theChartOnDrawn($event)">
    <dxi-series argumentField="DateFormatted" valueField="LagInDays_MinMaxLimited" type="spline" color="#a3aaaa"></dxi-series>

    <dxo-argument-axis>
      <dxo-label [customizeText]="customizeTextArgument"></dxo-label>
    </dxo-argument-axis>

    <dxi-value-axis tickInterval="0.5" minValueMargin="0" maxValueMargin="0" [visualRange]="visualRange">
      <dxo-label [customizeText]="customizeTextValue"></dxo-label>
      <dxi-strip [startValue]="reportReportElement.MaximumThresholdInDays" color="rgba(255,155,85,0.15)">
        <dxo-label text="">
          <dxo-font [color]="highThresholdColor"></dxo-font>
        </dxo-label>
      </dxi-strip>
      <dxi-strip [endValue]="reportReportElement.MinimumThresholdInDays" color="rgba(97,153,230,0.10)">
        <dxo-label text="">
          <dxo-font [color]="lowThresholdColor"></dxo-font>
        </dxo-label>
      </dxi-strip>
      <dxo-strip-style>
        <dxo-label>
          <dxo-font [weight]="500" [size]="14"></dxo-font>
        </dxo-label>
      </dxo-strip-style>
    </dxi-value-axis>

    <dxo-legend [visible]="false"></dxo-legend>
    <dxo-export [enabled]="false"></dxo-export>
    <dxo-tooltip [enabled]="true"
                 [shared]="true"
                 contentTemplate="toolTipTemplate">
    </dxo-tooltip>

    <div *dxTemplate="let t of 'toolTipTemplate'" [style.color]="getPointColor(t.value)">
      <div style="white-space: nowrap;"><span style="font-weight: normal; opacity: 0.5;">{{ls.LNG('Label.Lag')}}</span>: <span style="font-weight: bold;">{{t.point.data.LagInDays.toFixed(1)}}</span></div>
      <div style="white-space: nowrap;"><span style="font-weight: normal; opacity: 0.5;">{{ls.LNG('Label.Date')}}</span>: <span style="font-weight: bold;">{{customizeTextArgument(t.argument)}}</span></div>
    </div>

  </dx-chart>
</div>

